const apis = {
    login: '/api/TokenAuth/Authenticate',
    register: '/api/services/app/Member/Register',
    password: '/api/services/app/User/UpdatePassword',
    // 限时特惠
    allAds: '/api/services/app/Ad/GetAllAds',
    preferential: '/api/services/app/Commodity/QueryPreferentialItems',
    hotSale: '/api/services/app/Commodity/QueryHotItems',
    categoryItems: '/api/services/app/Commodity/QueryTopCategoryItems',
    categoriesAndBrands:'/api/services/app/Commodity/GetCategorAndBrands',
    products:'/api/services/app/Commodity/Query',
    product:'/api/services/app/Commodity/Get',
    editShoppingCart:'/api/services/app/ShoppingCart/Edit',
    getShoppingCartList:'/api/services/app/ShoppingCart/GetList',
    updateShopCart: '/api/services/app/ShoppingCart/Update',
    clearShopCart: '/api/services/app/ShoppingCart/Clear',
    uploadFile:'/api/services/app/Common/UploadFile',
    saveAddressee:'/api/services/app/Member/SaveAddressee',
    getAddresses:'/api/services/app/Member/GetAddresses',
    deleteAddressee:'/api/services/app/Member/DeleteAddressee',
    getAddresseeByIDNO:'/api/services/app/Member/QueryAddresseesByIdCard',

    shopList:'/api/services/app/Shop/GetList', //门店列表
    shopInfo:'/api/services/app/Shop/GetInfo', //门店详情
    createOrder:'/api/services/app/Order/MemberSubmit', // 创建订单
    updateOrder: '/api/services/app/Order/Update',
    computeAmount:'/api/services/app/Order/ComputeAmount',
    orderDetail:'/api/services/app/Order/Get',
    orderCancel: '/api/services/app/Order/Cannel',
    pcPayQrCode:'/api/services/app/Payment/PcQrCodePay',
    payCashier: '/api/CNYPayment/Cashier',
    bankInfo:'/api/services/app/Configuration/GetBankCardSetting',
    getMyOrders:'/api/services/app/Order/GetMyOrders',
    getNews: '/api/services/app/Article/GetList',
    getNewsDetail: '/api/services/app/Article/GetInfo',
    getAppSetting: '/api/services/app/Configuration/GetAppSetting',
    getParcelList: '/api/services/app/Parcel/GetList',
    getParcelById: '/api/services/app/Parcel/Get',
    getParcelProduct: '/api/services/app/Parcel/GetProducts',
    submitParcel: '/api/services/app/Parcel/Submit',
    createExpressProduct: '/api/services/app/ExpressProduct/Create',
    deleteParcel: '/api/services/app/Parcel/Delete',
    shareToShop: '/api/services/app/Parcel/ShareToShop',
    cancelShareToShop: '/api/services/app/Parcel/CannelShareToShop',
    getTopList: '/api/services/app/Article/GetTopList',
    getCategories: '/api/services/app/Article/GetCategories',
    getExpQRCode: '/api/services/app/Parcel/GetExpressQRCode',

    //admin
    adminLoginUrl:'/api/TokenAuth/Authenticate',
    getOrders:'/api/services/app/Order/GetList',
    memberList: '/api/services/app/Member/GetList',

    //会员信息
    getMyInfo: '/api/services/app/Member/GetMyInfo',
    updateMyInfo: '/api/services/app/Member/UpdateMyInfo',
    getCoupons: '/api/services/app/Member/GetMyCoupons',
    queryMyOrderCout: '/api/services/app/Order/QueryMyOrderCout',
    updateRemark: '/api/services/app/Parcel/UpdateRemark',
    bindShop: '/api/services/app/Member/BindShop',

    //移动端独有的API：
    jsApiPay: '/api/services/app/Payment/JsApiPay',
    h5Pay: '/api/services/app/Payment/H5Pay',
    payNotify: '/api/services/app/Payment/RoyalpayNotify',
    payResult: '/api/services/app/Payment/PayResult',
    transferPay: '/api/services/app/Order/TransferPay',
    queyPayInfo: '/api/services/app/Order/QueryOrderPaymentInfo',
    commonPay: '/api/services/app/Payment/CommonPay',
    getJsSdkPackage:'/api/Wechat/GetJsSdkPackage',
    submitIdCardInfo: '/api/services/app/Parcel/SubmitIdCardInfo'
}
const mutationKeys = {
    setUserInfo:'setUser',
    userLogout:'userLogout',
}

const strings = {
    userToken:'as_user_token',
    adminToken:'as_admin_token',
    cart:'as_cart', //购物车本地存储，现在没用了。
}

const validate = {
    account: /^[a-zA-Z][a-zA-Z0-9]{3,15}$/,
    phone: /^(\d{11})|(\d{3}-\d{8})|(\d{4}-\d{7})$/,
    phoneSimple: /^1\d{10}$/,
    password: /^\S{6,32}$/,
    email: /^([A-Za-z0-9_\-\.\u4e00-\u9fa5])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/,
    idCard: /^(\d{14}|\d{17})[0-9Xx]$/,

    reg_int: /^[1-9]\d*$/,
    reg_decimal: /^((0\.\d{1,2})|([1-9]\d*(\.\d{1,2})?))$/,
}

export default {
    apis,
    mutationKeys,
    strings,
    validate
}
